export function isFeatureEnabledPercentage(userId: string, percentage: number): boolean {
  if (percentage <= 0) return false;
  if (percentage >= 100) return true;

  // FNV-1a 32-bit hash
  let hash = 2166136261;

  for (let i = 0; i < userId.length; i++) {
    hash ^= userId.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }

  const bucket = (hash >>> 0) % 100;

  return bucket < percentage;
}
